import urls from "../../../../global/constants/UrlConstants";
import {
  getCallParams,
  getNoAuthCallParams,
  makeCall,
} from "../../../../utils/service";

export async function getRoleById(roleId?: String) {
  try {
    const callParams = await getCallParams("GET");
    if (roleId && roleId != "") {
      const response = await makeCall(urls.GETROLEBYID + roleId, callParams);
      return response;
    } else {
      const response = await makeCall(urls.GETROLE, callParams);
      return response;
    }
  } catch (error) {
    throw error;
  }
}

export async function RegisterEmployee(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.REGISTERLEAD, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getPerosnalDetails(userId: String) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETEMPLOYEERECORDBYID + userId,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updatePersonalDetail(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATELEADDETAIL, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function updateExportDetails(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.UPDATELEADEXPORTDETAILS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updateOfficailInfo(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(
      urls.UPDATEEMPLOYEEOFFICIALDETAIL,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getOfficeDetails(userId: String) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETEMPLOYEEOFFICEDETAILBYID + userId,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getBankDetails(userId: String) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETEMPLOYEEBANKDETAILBYID + userId,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updateLeaveInfo(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATEEMPLOYEELEAVEINFO, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updateBankInfo(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATEEMPLOYEEBANKINFO, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getLeaveDetail(userId: String) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETEMPLOYEELEAVEDETAILBYID + userId,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function saveOfficialInfo(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.ADDUSEROFFICE, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function saveBankDetails(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.SAVEEMPLOYEEBANKINFO, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function saveLeaveDetails(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.SAVEEMPLOYEEBANKDETAILS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getSalaryDetail(userId: String) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETEMPLOYEESALARYDETAILBYID + userId,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updateSalaryInfo(body: any) {
  try {
    const callParams = await getCallParams("PUT", body);
    const response = await makeCall(urls.UPDATEEMPLOYEESALARYINFO, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function saveSalaryDetails(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.SAVEEMPLOYEESALARYDETAILS, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
